import Config from "../Config";

const ITEM_PRECISION_ACCURACY = Config.ITEM_PRECISION_ACCURACY;

export const isLowPrecision = (precision) => {
  return precision <= ITEM_PRECISION_ACCURACY;
};

// Normaliza o campo `message` do produto: aceita array (múltiplos alertas),
// objeto único (legado) ou vazio, retornando sempre um array.
export const getMessages = (message) => {
  if (Array.isArray(message)) return message;
  if (message) return [message];
  return [];
};

// Extrai a parte "limpa" de uma mensagem de erro para agrupar/filtrar por tipo.
export const cleanErrorMessage = (originalMessage) => {
  const original = (originalMessage || '').trim();
  let clean = original;
  if (original.startsWith('Não foi possível inserir o item.')) {
    clean = original.replace(/^Não foi possível inserir o item\.\s*/, '');
  } else {
    const firstDotIndex = original.indexOf('.');
    if (firstDotIndex !== -1) {
      clean = original.substring(0, firstDotIndex);
    }
  }
  return { original, clean: clean.trim() || original };
};

// Retorna as mensagens de erro (kind === 'error') de um produto, já limpas.
export const getProductErrorMessages = (product) => {
  return getMessages(product && product.message)
    .filter((msg) => msg && msg.message && msg.kind === 'error')
    .map((msg) => cleanErrorMessage(msg.message));
};

// Casa uma mensagem de erro (limpa/original) com uma seleção do filtro.
export const matchesSelectedError = ({ original, clean }, selectedMsg) => {
  return clean.includes(selectedMsg) || selectedMsg.includes(clean)
    || original.includes(selectedMsg) || selectedMsg.includes(original);
};

export const formatMoneyBRL = (valor) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor);
}

export const getQueryParam = (param) => {
  const search = window.location.hash.includes("?") ? window.location.hash.split("?")[1] : '';
  const urlParams = new URLSearchParams(search);
  return urlParams.get(param);
}

export const getContrast = (hex) => {
  const hexToRgb = (hex) => {
    if (Array.isArray(hex)) {
      return hex;
    }

    hex = hex.replace(/^#/, '');

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return [r, g, b];
  };

  if (!hex) return undefined;

  const rgb = hexToRgb(hex);
  const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;

  return brightness > 125 ? 'black' : 'white';
};

export const ORDER_STATUS = {
  CREATED: 'created',
  VIEWED: 'viewed',
  REVISED: 'revised',
  CANCELED: 'canceled',
  CLIENT_NOT_FOUND: 'client_not_found',
  SENT_TO_DEVICE: 'sent_to_device',
  INVALID_CONTENT: 'invalid_content'
}

export const getFileName = (item) => {
  const url = item.document_file;
  return url ? url.substring(url.lastIndexOf('/') + 1) : item.identifier;
}